module.exports = __webpack_public_path__ + "static/media/guest.2e222989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/guest.svg
// module id = 1051
// module chunks = 49